import { useEffect, useState } from 'react'

// * Components
import { Circle, Square, Triangle } from './Shapes'
import './styles.sass'

const Loader = () => {
  const [loader, setLoader] = useState(1)
  const [gradient, setGradient] = useState('')
  const [path, setPath] = useState('')
  useEffect(() => {
    const num = Math.floor(Math.random() * 3) + 1
    if (num === 1) {
      setGradient('linear-gradient(to top, rgba(34, 197, 94, .6), rgba(34, 197, 94, 1))')
      setPath('rgba(34, 197, 94, .5)')
    } else if (num === 2) {
      setGradient('linear-gradient(to bottom,rgba(69, 93, 235, 0.6),rgba(69, 93, 235, 1))')
      setPath('rgba(69, 93, 235, .5)')
    } else if (num === 3) {
      setGradient('linear-gradient(to bottom,rgba(59, 130, 246, .6),rgba(59, 130, 246, 1))')
      setPath('rgba(59, 130, 246, .5)')
    }
    setLoader(num)
  }, [])

  return (
    <div
      id="loader-container"
      className="loader-container"
      style={{
        // @ts-ignore
        '--path': path,
        '--dot': gradient,
      }}
    >
      {loader === 1 && <Circle />}
      {loader === 2 && <Square />}
      {loader === 3 && <Triangle />}
    </div>
  )
}

export default Loader
